/**
 * Per-user per-day tracker health counters (written / failed / retried).
 * Best-effort; never throws to callers.
 */
import { doc, setDoc, increment, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase';

export const CRM_TRACKER_HEALTH = 'crmTrackerHealth';

function dayKeyChicago(now: Date = new Date()): string {
  return now.toLocaleDateString('en-CA', { timeZone: 'America/Chicago' });
}

export async function bumpCrmTrackerHealth(
  userId: string,
  field: 'written' | 'failed' | 'retried',
  amount = 1,
): Promise<void> {
  if (!userId || amount === 0) return;
  const key = dayKeyChicago();
  const id = `${userId}_${key}`;
  try {
    await setDoc(
      doc(db, CRM_TRACKER_HEALTH, id),
      {
        userId,
        dateKey: key,
        [field]: increment(amount),
        updatedAt: serverTimestamp(),
      },
      { merge: true },
    );
  } catch (err) {
    console.error('[CrmTrackerHealth] bump failed:', err);
  }
}
